import { render, staticRenderFns } from "./SelectResourceContent.vue?vue&type=template&id=590dd4c1&scoped=true&"
import script from "./SelectResourceContent.vue?vue&type=script&lang=js&"
export * from "./SelectResourceContent.vue?vue&type=script&lang=js&"
import style0 from "./SelectResourceContent.vue?vue&type=style&index=0&id=590dd4c1&lang=scss&scoped=true&"
import style1 from "./SelectResourceContent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590dd4c1",
  null
  
)

export default component.exports